import { useContext } from "react";
import { Navigate } from "react-router";
import { AppContext } from "../../../contexts/AppContext";
import { LoadingContent } from "../Shared/LoadingContent";
import { UserType } from "../../Variables";

/// Makes sure that the user is a candidate to render its child content, if the user is not a candidate the page redirects to the landing page
export const CandidateOnlyRoute = (props: React.PropsWithChildren<any>) => {
    const app = useContext(AppContext);

    if (!app.loading && app.loggedInUser.UserType != UserType.Candidate) {
        // user is not allowed
        return <Navigate to="/" />;
    }

    return (<>
        <LoadingContent loading={app.loading} classes="w-100 text-center">
            {props.children}
        </LoadingContent>
    </>);
}